var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3194 18.11c0-2.6458 2.1448-4.7906 4.7905-4.7906H200.236c2.645 0 4.79 2.1448 4.79 4.7905V222.508c0 2.646-2.145 4.79-4.79 4.79H20.1099c-2.6457 0-4.7905-2.144-4.7905-4.79V18.11z",
    fill: "#fff",
    stroke: "#E9E9E9",
    strokeWidth: 0.638743
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#E9E9E9",
    d: "M27.7749 116.476h151.382v7.02618H27.7749zM27.7749 130.529H89.733v7.02618H27.7749z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F1F3F4",
    d: "M27.7749 144.581H89.733v7.02618H27.7749z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F9F9F9",
    d: "M27.7749 186.738H89.733v7.02618H27.7749zM27.7749 203.984H89.733v7.02618H27.7749z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.7973,
    cy: 90.9266,
    rx: 16.0224,
    ry: 15.9686,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7749,
    y: 25.7749,
    width: 22.9948,
    height: 22.9948,
    rx: 1.27749,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.6021,
    y: 25.7749,
    width: 22.9948,
    height: 22.9948,
    rx: 1.27749,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 61.5444h190.346v.6388H15v-.6388zM15 168.215h190.346v.638H15v-.638z",
    fill: "#F1F3F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0784 47.4923c0-2.6458 2.1448-4.7906 4.7906-4.7906h180.126c2.645 0 4.79 2.1448 4.79 4.7906V251.89c0 2.646-2.145 4.791-4.79 4.791H101.869c-2.6458 0-4.7906-2.145-4.7906-4.791V47.4923z",
    fill: "#fff",
    stroke: "#E9E9E9",
    strokeWidth: 0.638743
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#E9E9E9",
    d: "M109.534 145.859h151.382v7.02618H109.534zM109.534 159.911h61.9581v7.02618H109.534z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F1F3F4",
    d: "M109.534 173.963h61.9581v7.02618H109.534z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F9F9F9",
    d: "M109.534 216.121h61.9581v7.02618H109.534zM109.534 233.367h61.9581v7.02618H109.534z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.556,
    cy: 120.309,
    rx: 16.0224,
    ry: 15.9686,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.534,
    y: 55.1572,
    width: 22.9948,
    height: 22.9948,
    rx: 1.27749,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.361,
    y: 55.1572,
    width: 22.9948,
    height: 22.9948,
    rx: 1.27749,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.759 90.9268h190.346v.6387H96.759v-.6387zM96.759 197.597h190.346v.639H96.759v-.639z",
    fill: "#F1F3F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.596121,
    y: 0.516638,
    width: 219.153,
    height: 243.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20194
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 82.3552,
    y: 29.899,
    width: 219.153,
    height: 243.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20194
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.97be68a7.svg";
export { ForwardRef as ReactComponent };